import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";

//react-bootstrap
import { Container, Row, Col } from "react-bootstrap";

interface IHeroBanner {
    sectionId: string;
    background: string;
    webPBackground?: string;
    imgAlt?: string;
    title: string;
    subtitle?: string;
    description?: string;
    action?: JSX.Element;
}

const HeroHeader: React.FC<IHeroBanner> = (props) => {
    const { t } = useI18next();
    const { sectionId, background, webPBackground, imgAlt, title, subtitle, description, action } = props;
    return (
        <section id={sectionId} className="hero-header parallax-banner">
            <div className="parallax-banner-wrapper">
                <picture>
                    <source srcSet={webPBackground} className="parallax-banner-img" type="image/webp" />
                    <source srcSet={background} className="parallax-banner-img" type="image/jpeg" />
                    <img alt={imgAlt || ""} className="parallax-banner-img" src={background} />
                </picture>
            </div>
            <div className="parallax-content">
                <Container className="container">
                    <Row className="justify-content-center text-center">
                        <Col className="col">
                            <h1 className="font-weight-bold">{title}</h1>
                            {subtitle && <p className="font-weight-semibold text-gray-100 ">{subtitle}</p>}
                            {description && <span className="media-body text-white m-0 small">{description}</span>}
                        </Col>
                    </Row>
                    {action && <Row className="header-action">{props.action}</Row>}
                </Container>
            </div>
        </section>
    );
};

export default HeroHeader;
